var render = function (_h,_vm) {var _c=_vm._c;return _c('transition-group',{staticClass:"animated-list",attrs:{"tag":_vm.props.tag,"name":"item"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }